import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPerformance } from "../../../../service/endpoints";

export const PerformanceHandler = createAsyncThunk('PerformanceHandler', async () => {
    try {
        const response = await getPerformance()
        console.log(response.data,'dashboard')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
    })


const PerformanceSlice = createSlice({
    name: 'get_performance',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(PerformanceHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(PerformanceHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(PerformanceHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        });
    }

})

export default PerformanceSlice.reducer;